import { Nav } from "react-bootstrap";
import {
  FaBars,
  FaTimes,
  FaLaptop,
  FaBoxes,
  FaExchangeAlt,
  FaClipboardList,
  FaChartLine,
  FaFileAlt,
  FaHeartbeat
} from "react-icons/fa";

import "../Sidebar.css";
import { NavLink } from "react-router-dom";

const Sidebar = ({ isOpen, toggleSidebar }) => {

  const menuItems = [

    {
      title: "Item Entry",
      path: "/itementry",
      icon: <FaLaptop />,
    },

    {
      title: "Item Receive",
      path: "/itemreceive",
      icon: <FaBoxes />,
    },

    {
      title: "Item Issue",
      path: "/itemissue",
      icon: <FaExchangeAlt />,
    },

    {
      title: "Issue To Employee",
      path: "/issuereport",
      icon: <FaClipboardList />,
    },

    {
      title: "First Moving Items",
      path: "/firstMovingItems",
      icon: <FaChartLine />,
    },

    {
      title: "Monthly Issue Register",
      path: "/monthlyIssueRegister",
      icon: <FaFileAlt />,
    },

  ];

  return (

    <div
      className={`sidebar ${
        isOpen ? "open" : "collapsed"
      }`}
    >

      {/* Header */}

      <div className="sidebar-header">

        {isOpen && (
          <div className="brand-section">

            <div className="brand-icon">
              <FaHeartbeat />
            </div>

            <div>
              <h5 className="brand-title">
                MEDICAL
              </h5>

              <small className="brand-subtitle">
                Management System
              </small>
            </div>

          </div>
        )}

        <button
          onClick={toggleSidebar}
          className="toggle-btn"
        >
          {isOpen ? <FaTimes /> : <FaBars />}
        </button>

      </div>

      {/* Menu */}

      <Nav className="flex-column sidebar-menu">

        {menuItems.map((item, index) => (

          <NavLink
            key={index}
            to={item.path}
            end
            className={({ isActive }) =>
              `sidebar-link ${
                isActive ? "active-menu" : ""
              }`
            }
          >

            <span className="menu-icon">
              {item.icon}
            </span>

            {isOpen && (
              <span className="menu-title">
                {item.title}
              </span>
            )}

          </NavLink>

        ))}

      </Nav>

      {/* Footer */}

      {isOpen && (
        <div className="sidebar-footer">
          © 2026 MIS & ICT
        </div>
      )}

    </div>
  );
};

export default Sidebar;